export enum QCTScanTypeEnum {
  LUMBAR_SPINE = 'LUMBAR_SPINE',
  HIP = 'HIP',
}
export type QCTScoreData = {
  /** Not rendered: the scan's identity, and the planned (i) hint. */
  fileName: string | null;
  /** `null` when the workstation reported a scan family this app does not know. */
  scanType: QCTScanTypeEnum | null;
  /** EXAM_DATE — the acquisition date the results are grouped by. */
  examDate: string | null;
};

export type QCTWorkstationEntry = {
  /** Record name as the workstation stored it — used as the row's file name. */
  name?: string | null;
  bodyProperty?: string | null;
  analysisProgram?: string | null;
  examDate?: string | null;
  creationDate?: string | null;
  creationTime?: string | null;
  entryIndex?: number | null;
  data?: Record<string, string | number | null> | null;
};

/** `QctWorkstationDataDto` — one record returned by `GET /qc/tasks/:taskId/qct-workstation-data`. */
export type QCTWorkstationDataDTO = {
  id: string;
  clinicalTrialId: string;
  siteId: string;
  patientId: string;
  visitId: string;
  gender: string | null;
  ethnicity: string | null;
  dob: string | null;
  /** One entry per analysed scan. A record can report more than one. */
  data: QCTWorkstationEntry[];
};

export type QCTVisitLabeledScore = {
  referenceId: string;
  labelId: string | null;
  data: QCTWorkstationEntry;
};

/** `QctVisitDataDto` — the whole selection for a visit. `data` is required, never null. */
export type QCTVisitDataDTO = {
  data: QCTVisitLabeledScore[];
};

export type QCTReading = QCTScoreData & {
  referenceId: string;
  rowKey: string;
  labelId: string | null;
  labelName?: string;
  entry: QCTWorkstationEntry;
  scoreIndex?: number;
};
